const FormSection = ({ title, children }) => {
  return (
    <div className="ui-card p-5 md:p-6">
      <div className="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
        <div className="h-8 w-1.5 rounded-full bg-red-600" />
        <h3 className="text-base font-semibold uppercase tracking-[0.08em] text-slate-800">{title}</h3>
      </div>
      {children}
    </div>
  );
};

export default FormSection;
